import Cookies from "js-cookie";
import { useContext, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { UserContext } from "providers/UserProvider";

import { ReactComponent as R2C2Logo } from "assets/svgs/R2C2Logo.svg";
import ToastsContainer from "components/layout/ToastContainer";

const WebAppLayout = () => {
    const location = useLocation();

    const path = (location.pathname || "/").replace(/\/+$/, "") || "/";
    const isMapEditorPage =
        path === "/fleet/map/editor" || path === "/arc/map/editor";

    // Detect if we're in ARC mode (no authentication required)
    const isArcMode = location.pathname.startsWith("/arc");

    // UserProvider only available in fleet mode, not in ARC mode
    const userContext = useContext(UserContext);

    // Only run authentication check in fleet mode
    useEffect(() => {
        if (isArcMode) return; // Skip authentication for ARC mode

        let userToken;
        if (sessionStorage.getItem("userToken")) {
            console.log('getting session token')
            userToken = sessionStorage.getItem("userToken");
        } else {
            console.log('getting cookie token')
            userToken = Cookies.get("userToken");
        }

        // TODO: investigate user token can't be fetched after setting and uncomment this block
        // if (!userToken) {
        //     console.log('no user token')
        //     return navigate("/fleet/login", { replace: true });
        // }

        // Set user token only if UserProvider is available (fleet mode)
        if (userContext?.setUserToken) {
            userContext.setUserToken(userToken);
        }

        return () => sessionStorage.clear();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isArcMode, userContext]);

    return (
        <div className="layout relative overflow-hidden">
            {!isMapEditorPage ? <R2C2Logo className="absolute left-4 top-[1.375rem] z-10 h-9 w-12" /> : null}
            <div className="layout absolute left-0 top-0 z-0 flex flex-col overflow-hidden">
                <ToastsContainer />
                <Outlet />
            </div>
        </div>
    );
};

export default WebAppLayout;
